// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";

const uri = "api/custom/CustomerCreditInformation/GetCustomerCreditInformation";

type CustomerCreditInformationResult = {
    erpNumber: string;
    showSoftHoldWarningMessage: boolean;
    showHardHoldWarningMessage: boolean;
    successful: boolean;
};

export async function getCustomerCreditInformation() {
    try {
        const result = await get<CustomerCreditInformationResult>(`${uri}`);
        return {
            successful: true,
            erpNumber: result.erpNumber,
            showSoftHoldWarningMessage: result.showSoftHoldWarningMessage,
            showHardHoldWarningMessage: result.showHardHoldWarningMessage,
        };
    } catch (error) {
        return {
            successful: false,
            erpNumber: "",
            showHardHoldWarningMessage: false,
            showSoftHoldWarningMessage: false,
        };
    }
}
